import { Observable } from "rxjs";
import api from "../api-config/rxjs-config";
import { QueryParams } from "@/models/query-params.model";

export class EventsRest {
  addFeedbackEvent(courseId: string, userId: string, data: any, params:QueryParams): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}/events/feedbacks`;
    return api.post(url, data, params, "/graphs");
  }
  addMaterialEvent(courseId: string, userId: string, data: any, params): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}/events/materials`;
    return api.post(url, data, params, "/graphs");
  }
  addQuizEvent(courseId: string, userId: string, data: any, params): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}/events/quizzes`;
    return api.post(url, data, params, "/graphs");
  }
}
